import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { ProductImage } from './ProductImage';
import { PRODUCT_NAME, PRICE, REGULAR_PRICE } from './constants';
const items = ['6 Professional Modules', '5 Premium Bonuses', 'Ready-to-Teach PE Lessons', 'Activity Library', 'Skill Progressions', 'Fitness Sessions', 'Class Management Tools', 'Assessment Resources'];
export function PricingCard() {
  return <section id="pricing" className="bg-brand-navy px-4 py-7 scroll-mt-2 border-y-4 border-brand-orange" data-id="element-118" data-mp="29u5j71omk6f8">
      <div className="max-w-2xl mx-auto text-center" data-id="element-119" data-mp="2523xkp5kh3cj">
        <p className="font-heading font-extrabold text-xs sm:text-sm text-brand-orange uppercase tracking-[0.2em] mb-2" data-id="element-120" data-mp="250suysnuy1n0">
          Special Launch Offer
        </p>

        <p className="font-display text-3xl sm:text-4xl text-white leading-none" data-id="element-121" data-mp="2xl16bli4ydg5">
          🏃 {PRODUCT_NAME}
        </p>
        <p className="font-heading font-semibold text-[13px] sm:text-sm text-white/85 uppercase tracking-wide leading-snug mt-1 mb-3" data-id="element-122" data-mp="2sqn7ta86fq79">
          The Complete Ready-to-Teach System for Physical Education Teachers
        </p>

        <ProductImage toCheckout className="max-w-[240px] sm:max-w-[280px] mb-3" data-id="element-123" data-mp="2susopm91g6du" />

        <div className="bg-white rounded-2xl border-4 border-brand-green p-4 sm:p-5 shadow-2xl" data-id="element-124" data-mp="2xt3xdtnlkauh">
          <p className="font-heading font-extrabold text-sm text-brand-navy uppercase tracking-wide mb-2.5" data-id="element-125" data-mp="2jtbdah6kssvh">
            Complete 6-in-1 PE Teaching System
          </p>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 text-left mb-3" data-id="element-126" data-mp="2oqkzlnyo4of3">
            {items.map(item => <li key={item} className="flex items-start gap-1.5 text-[13px] sm:text-sm text-brand-ink font-medium leading-snug" data-id="element-127" data-mp="2eu872tev0glx">
                <CheckIcon className="w-4 h-4 text-brand-green shrink-0 mt-0.5" aria-hidden="true" data-id="element-128" data-mp="d3ek3l2jkx3w" />
                {item}
              </li>)}
          </ul>

          <div className="bg-brand-cream rounded-xl border border-brand-line py-3 px-4 mb-3" data-id="element-129" data-mp="6mlga5doqqk1">
            <p className="font-heading font-extrabold text-sm text-brand-orange uppercase tracking-wide mb-0.5" data-id="element-130" data-mp="1ni8wea8g88w">
              🔥 Get {PRODUCT_NAME} Today
            </p>
            <p className="text-sm font-heading font-semibold text-brand-slate" data-id="element-131" data-mp="3tu72e4i0e1pm">
              Regular Price: <span className="line-through" data-id="element-132" data-mp="uejuoy8fl21e">${REGULAR_PRICE}</span>
            </p>
            <p className="font-display text-5xl sm:text-6xl text-brand-navy leading-none" data-id="element-133" data-mp="pee7pvd3w3pn">
              ${PRICE} USD
            </p>
          </div>

          <CTAButton toCheckout data-id="element-134" data-mp="glu8asozpv3r">🏃 YES! I WANT THE COMPLETE SYSTEM</CTAButton>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 mt-2.5 text-xs sm:text-sm font-heading font-bold text-brand-navy" data-id="element-135" data-mp="1d36xtb71rhcc">
            <span className="inline-flex items-center gap-1.5" data-id="element-136" data-mp="18axc67cyt3fv">
              <ZapIcon className="w-4 h-4 text-brand-orange" aria-hidden="true" data-id="element-137" data-mp="2qzrqgvrx3n7n" />
              Immediate Digital Access
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-138" data-mp="3006g27bwzogy">
              <ShieldCheckIcon className="w-4 h-4 text-brand-green" aria-hidden="true" data-id="element-139" data-mp="2zylngn95uflq" />
              🛡️ 14-Day Money-Back Guarantee
            </span>
          </div>
        </div>
      </div>
    </section>;
}